export const LOGIN_ROUTE = "/login";
export const FORGOT_PASSWORD_ROUTE = "/forgot-password";
export const FORGOT_PASSWORD_RESET_ROUTE = "/forgot-password/reset";

export const UPDATE_PASSWORD_ROUTE = "/admin/setPassword";

export const ADMIN_ROUTE = "/admin";
export const ADMIN_DETAILS_ROUTE = ":adminId";

export const DASHBOARD_ROUTE = "/";
export const OPERATOR_DASH = "/operator/dashboard";
export const BOOKING_ROUTE = "/bookings";
export const BOOKING_DETAILS_ROUTE = ":bookingId";
export const PROPERTIES_ROUTE = "/properties";
export const PROPERTIES_UPDATE_ROUTE = "update/:propertyId";
export const PROPERTIES_DETAILS_ROUTE = ":propertyId";
export const PROPERTIES_REVIEW_ROUTE = "review/:propertyId";

export const USERS_ROUTE = "/users";
export const USERS_DETAILS_ROUTE = ":userId";
export const USERS_TRANSACTION_DETAIL_ROUTE = ":transactionId";
export const ADD_USER_ROUTE = "/addUser";
export const ADD_ADMIN_ROUTE = "/addAdmin";
export const EDIT_USER_ROUTE = "/editUser/:id";

export const JOBS_ROUTE = "/jobs";
export const JOBS_DETAILS_ROUTE = ":jobId";

export const PROFILE_ROUTE = "/profile";
export const REPORTS_ROUTE = "/reports";
export const REPORT_ROUTE = ":id";
export const SETTINGS_ROUTE = "/settings";
export const SCRAPPED_ROUTE = "/scrapped";
// export const AMENITIES = "/amenities";
export const UTILITY_CATEGORIES_ROUTE = "/setting/categories";
export const UTILITY_PROVIDERS_ROUTE = "/setting/providers";
export const UTILITY_PROVIDER_DETAILS_ROUTE = ":providerId";
export const AMENITIES_ROUTE = "/setting/amenities";
export const CONTRACT_ROUTE = "/contract/:contractId";

export const PROPERTY_RESOURCE = "/resources/property";
export const MARKETPLACE_RESOURCE = "/resources/marketplace";
export const TRADE_RESOURCE = "/resources/trade";
export const RATING_RESOURCE = "/resources/rating";

export const EMPLOYERS_ROUTE = "/setting/employers";
export const EMPLOYERS_ROUTE_DETAILS_ROUTE = ":employerId";
export const DEV_ROUTE_DETAILS_ROUTE = "/globalSettings";

export const Notification_ROUTE = "/notifications";
